"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getParticipantStatusLabel = void 0;
const participant_vg_state_1 = require("../enums/participant-vg-state");
function getParticipantStatusLabel(fullName, state, audioPath, phoneticPronunciation) {
    switch (state) {
        case participant_vg_state_1.ParticipantVirtualGraduationState.New:
            return "New";
        case participant_vg_state_1.ParticipantVirtualGraduationState.Invited:
            return "Invited";
        case participant_vg_state_1.ParticipantVirtualGraduationState.Rejected:
            return "Rejected";
        case participant_vg_state_1.ParticipantVirtualGraduationState.Submitted:
            return "Submitted";
        case participant_vg_state_1.ParticipantVirtualGraduationState.Accepted:
            return "Suggested Pronunciation";
        case participant_vg_state_1.ParticipantVirtualGraduationState.AdminConfirmed:
            return "Admin Confirmed";
        case participant_vg_state_1.ParticipantVirtualGraduationState.Confirmed:
            if (audioPath || phoneticPronunciation ? fullName !== phoneticPronunciation : false) {
                return "Admin Confirmed";
            }
            return "Student Confirmed";
        default:
            return "Unknown";
    }
}
exports.getParticipantStatusLabel = getParticipantStatusLabel;
//# sourceMappingURL=participant-status.js.map